/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, clientID, CompanyID, isEmpty, isSingleSelect } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "smsCampaign";
var moduleName = "SMS Campaign";
var modulePath = "/clientpanel/smsCampaign";

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        smscampaignTitle: "",
        smscampaignMessage: "",
        smscampaignSchedule: "",
        selectedCustomer: [],
        status: "",
        action: "add",
      },
      loading: true,
      formpost: [],
      companyDetail: [],
      customerList: [],
    };
  }
  componentDidMount() {
    this.loadCustomers();
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: apiUrl + module + "/details/" + this.state.editID,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var smscampaignStatus = result.smscampaignStatus == "A" ? "Active" : "Inactive";
          var status =
            result.smscampaignStatus !== "" && result.smscampaignStatus !== null
              ? {
                  label: smscampaignStatus,
                  value: result.smscampaignStatus,
                }
              : "";

          var clientupdatedata = {
            smscampaignTitle: result.smscampaignTitle,
            smscampaignMessage: result.smscampaignMessage,
            selectedCustomer: result.selectedCustomer,
            smscampaignSchedule: result.smscampaignSchedule !== null && result.smscampaignSchedule !== "" ? new Date(result.smscampaignSchedule) : "",
            status: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {};

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: value } } }));
  };

  loadCustomers() {
    var urlShringTxt = apiUrl + "customer/dropdownlist";

    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ customerList: res.data.result });
      }
    });
  }
  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    var selectedCustomer = [];
    if (postData.selectedCustomer.length > 0) {
      postData.selectedCustomer.map((item) => {
        selectedCustomer.push(item.value);
        return "";
      });
    }
    var selectedCustomers = selectedCustomer.length > 0 ? selectedCustomer.join(",") : "";

    var postObject = {
      smscampaignTitle: postData.smscampaignTitle,
      smscampaignMessage: postData.smscampaignMessage,
      selectedCustomer: selectedCustomers,
      smscampaignSchedule: postData.smscampaignSchedule !== "" ? format(postData.smscampaignSchedule, "yyyy-MM-dd H:mm:00") : "",
      smscampaignStatus: Object.keys(postData.status).length > 0 ? postData.status.value : "A",
      loginID: clientID(),
      company_admin_id: clientID(),
      company_id: CompanyID(),
      action: postData.action,
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"smscampaign"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>

                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  customerList={this.state.customerList}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { smscampaignTitle, smscampaignMessage, smscampaignSchedule, status } = props.fields;
  return {
    fields: ["smscampaignTitle", "smscampaignMessage", "smscampaignSchedule", "status"],
    validations: {
      smscampaignTitle: [[isEmpty, smscampaignTitle]],
      smscampaignMessage: [[isEmpty, smscampaignMessage]],
      smscampaignSchedule: [[isEmpty, smscampaignSchedule]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      source: "",
      destination: "",
      message: "",
      totalLength: 0,
      smsCount: 0,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.fields.smscampaignMessage !== this.state.message) {
      var totalLength = nextProps.fields.smscampaignMessage !== "" ? nextProps.fields.smscampaignMessage.length : 0;
      var totalSMS = totalLength <= 160 ? 1 : Math.ceil(totalLength / 160);
      this.setState({
        totalLength: totalLength,
        smsCount: totalSMS,
      });
    }
  }
  handleChange(name, value) {
    if (name === "smscampaignMessage") {
      var totalLength = value.target.value.length;
      var totalSMS = totalLength <= 160 ? 1 : Math.ceil(totalLength / 160);
      this.props.onChange(name, value.target.value);
      this.setState({ totalLength: value.target.value.length, smsCount: totalSMS });
    } else {
      this.props.onChange(name, value);
    }
  }
  changeSearch(name, e) {
    this.setState({ [name]: e.target.value });
  }

  sectCustomer(cust, type) {
    var updCust = this.props.fields.selectedCustomer;
    if (type === "add") {
      updCust.push(cust);
    } else if (type === "remove") {
      const index = updCust.indexOf(cust);
      updCust.splice(index, 1);
    }
    this.props.onChange("selectedCustomer", updCust);
  }
  checkingCust(currentCust, custLabel) {
    let selectedCustomer = this.props.fields.selectedCustomer;
    let updCustomer = [];
    console.log(selectedCustomer, "selectedCustomerselectedCustomer");
    selectedCustomer.map((item) => {
      updCustomer.push(item.value);
    });
    if (updCustomer.indexOf(currentCust) < 0) {
      var source = this.state.source;
      if (source !== "") {
        if (custLabel.toLowerCase().indexOf(source.toLowerCase()) >= 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  checkingSelectCust(custLabel) {
    var destination = this.state.destination;
    if (destination !== "") {
      if (custLabel.toLowerCase().indexOf(destination.toLowerCase()) >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  selectAll(type) {
    let customerList = type === "add" ? this.props.customerList : [];
    this.props.onChange("selectedCustomer", customerList);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgsmscampaignTitle,
      errMsgsmscampaignMessage,
      errMsgselectedCustomer,
      errMsgsmscampaignSchedule,
      errMsgStatus = "";
    if ($validation.smscampaignTitle.error.reason !== undefined) {
      errMsgsmscampaignTitle = $validation.smscampaignTitle.show && <span className="error">{$validation.smscampaignTitle.error.reason}</span>;
    }
    if ($validation.smscampaignMessage.error.reason !== undefined) {
      errMsgsmscampaignMessage = $validation.smscampaignMessage.show && <span className="error">{$validation.smscampaignMessage.error.reason}</span>;
    }
    if ($validation.smscampaignSchedule.error.reason !== undefined) {
      errMsgsmscampaignSchedule = $validation.smscampaignSchedule.show && <span className="error">{$validation.smscampaignSchedule.error.reason}</span>;
    }

    /* if ($validation.selectedCustomer.error.reason !== undefined) {
      errMsgselectedCustomer = $validation.selectedCustomer.show && (
        <span className="error">
          {$validation.selectedCustomer.error.reason}
        </span>
      );
    } */

    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && <span className="error">{$validation.status.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgsmscampaignTitle !== "" && errMsgsmscampaignTitle !== false && errMsgsmscampaignTitle !== undefined ? "form-control is-invalid" : "form-control"}
                name="smscampaignTitle"
                value={fields.smscampaignTitle}
                {...$field("smscampaignTitle", (e) => onChange("smscampaignTitle", e.target.value))}
              />
              <label htmlFor="smscampaignTitle">
                Title <span className="error">*</span>
              </label>
              {errMsgsmscampaignTitle}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4 custm-date-box">
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                showTimeSelect
                dropdownMode="select"
                className="form-control"
                selected={fields.smscampaignSchedule}
                timeIntervals={5}
                minDate={new Date()}
                dateFormat="dd/MM/yyyy h:mm aa"
                onChange={this.handleChange.bind(this, "smscampaignSchedule")}
              />
              <label className="select-box-label">Schedule Date & Time</label>
              {errMsgsmscampaignSchedule}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <textarea
                className={
                  errMsgsmscampaignMessage !== "" && errMsgsmscampaignMessage !== false && errMsgsmscampaignMessage !== undefined ? "form-control h-px-100 is-invalid" : "form-control h-px-100"
                }
                name="smscampaignMessage"
                value={fields.smscampaignMessage}
                onChange={this.handleChange.bind(this, "smscampaignMessage")}
              ></textarea>
              <label htmlFor="smscampaignTitle">
                Message <span className="error">*</span>
              </label>
              {errMsgsmscampaignTitle}

              <h4 class="display-6 mt-1">
                SMS character <b>{this.state.totalLength}</b>(SMS count <b>{this.state.smsCount}</b>)
              </h4>
            </div>
          </div>
          <div className="col-md-6"></div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.status}
                onChange={this.handleChange.bind(this, "status")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-12 dual-listbox-main">
            <div class="dual-listbox">
              <div class="list-container">
                <input type="text" class="search" placeholder="Search..." value={this.state.source} onChange={this.changeSearch.bind(this, "source")} />
                {this.props.customerList.length > 0 && (
                  <ul class="list" id="list1">
                    {this.props.customerList.map((item, index) => {
                      const checkingCust = this.checkingCust(item.value, item.label);
                      if (checkingCust === true) {
                        return (
                          <li key={index} onClick={this.sectCustomer.bind(this, item, "add")}>
                            {item.label}
                          </li>
                        );
                      } else {
                        return "";
                      }
                    })}
                  </ul>
                )}
              </div>
              <div class="buttons">
                <button type="button" onClick={this.selectAll.bind(this, "add")} title="Select All">
                  →
                </button>
                <button type="button" onClick={this.selectAll.bind(this, "remove")} title="Remove All">
                  ←
                </button>
              </div>
              <div class="list-container">
                <input type="text" class="search" value={this.state.destination} placeholder="Search..." onChange={this.changeSearch.bind(this, "destination")} />
                <ul class="list" id="list2">
                  {fields.selectedCustomer.length > 0 &&
                    fields.selectedCustomer.map((item, index) => {
                      const checkingSelectCust = this.checkingSelectCust(item.label);
                      if (checkingSelectCust === true) {
                        return (
                          <li key={index} onClick={this.sectCustomer.bind(this, index, "remove")}>
                            {item.label}
                          </li>
                        );
                      }
                    })}
                </ul>
                {errMsgselectedCustomer}
              </div>
            </div>
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
